import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareInboxClassicRoute: InvariantJiraRoute = {
	name: 'inbox-classic',
	path: '/jira/software/c/projects/:projectKey/inbox/:issueKey?',
};
